<div class="profile-box info-box flex flex-col">
  <header class="accent">
    <div i18n class="title">Документ удостоверяющий личность</div>
  </header>

  <div class="content">
    <mat-list>
      <mat-list-item
        ><span i18n>Серия, номер документа</span>:
        {{ client.seriesDocument + ' ' + client.numberDocument }}</mat-list-item
      >
      <mat-list-item
        ><span i18n>Дата выдачи документа</span>: {{ client.dateOfIssueDocument | date : 'shortDate' }}</mat-list-item
      >
    </mat-list>
  </div>
</div>
